import { useCountdownTimer } from '@/hooks/useCountdownTimer';
import { eventBus } from '@/hooks/useEventBus';
import { useEffect } from 'react';

type GameTimerProps = {
  timer?: number;
};
const GameTimer = ({ timer }: GameTimerProps) => {
  if (!timer) return <></>;
  const onComplete = () => {
    eventBus.emit('game_over');
  };
  const { seconds, start } = useCountdownTimer(timer, onComplete);

  useEffect(() => {
    setTimeout(() => {
      start();
    }, 1000);
  }, []);
  return (
    <div className="absolute top-2 right-2">
      <div className="flex justify-end">
        <div
          className="text-[20px] border-4 border-gray-600  rounded-full h-12 w-12 self-center flex justify-center items-center text-white border-[#bfc0f9ac] !bg-[#00025166]"
          id="timer"
        >
          {seconds}
        </div>
      </div>
    </div>
  );
};

export default GameTimer;
